import {
  Application,
  ApplicationList,
  Participant,
  ParticipantHistory,
  ParticipantList,
  type ApplicationDecision,
  type ApplicationDraft,
  type ApplicationStatus,
  type ParticipantDetails,
  type ParticipantStatus,
  type ParticipantUpdate,
} from '@regigov/contracts';
import { api } from './client';

const json = (body: unknown): RequestInit => ({ method: 'POST', body: JSON.stringify(body) });

export const applicationsApi = {
  mine: () => api('/applications/mine', Application),
  create: (draft: ApplicationDraft) => api('/applications', Application, json(draft)),
  update: (id: string, draft: ApplicationDraft) => api(`/applications/${id}`, Application, { method: 'PUT', body: JSON.stringify(draft) }),
  submit: (id: string) => api(`/applications/${id}/submit`, Application, { method: 'POST' }),
  list: (status?: ApplicationStatus) => api(`/applications${status ? `?status=${status}` : ''}`, ApplicationList),
  get: (id: string) => api(`/applications/${id}`, Application),
  addNote: (id: string, body: string) => api(`/applications/${id}/notes`, Application, json({ body })),
  decide: (id: string, decision: ApplicationDecision) => api(`/applications/${id}/decision`, Application, json(decision)),
};

export interface SelfUpdate {
  details: Partial<Pick<ParticipantDetails, 'tradingName' | 'contactName' | 'contactEmail' | 'contactPhone' | 'address'>>;
  changeReason: string;
}

export const participantsApi = {
  me: () => api('/participants/me', Participant),
  myHistory: () => api('/participants/me/history', ParticipantHistory),
  updateMe: (update: SelfUpdate) => api('/participants/me', Participant, { method: 'PATCH', body: JSON.stringify(update) }),
  search: (q: string, status?: ParticipantStatus) => {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (status) params.set('status', status);
    const qs = params.toString();
    return api(`/participants${qs ? `?${qs}` : ''}`, ParticipantList);
  },
  get: (id: string) => api(`/participants/${id}`, Participant),
  history: (id: string) => api(`/participants/${id}/history`, ParticipantHistory),
  update: (id: string, update: ParticipantUpdate) => api(`/participants/${id}`, Participant, { method: 'PATCH', body: JSON.stringify(update) }),
};
